// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {postMassLaborRates} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const postMassLaborRateChange = laborRate =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const updatedLaborRate = [
                ...laborRate
            ];

            await postMassLaborRates(updatedLaborRate);

            successAlertBar(translate('LABOR_RATE_CHANGE_SUBMITTED'));
            dispatch(routerActions.push('/claims/labor-rates?submitted=true'));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/mass-post-labor-rate.js